export default {
  serverUrl: process.env.REACT_APP_SERVER_URL,
  compassAppUrl: process.env.REACT_APP_COMPASS_APP_URL,
  compassSiteUrl: process.env.REACT_APP_COMPASS_SITE_URL,
  googleSecretKey: process.env.REACT_APP_GOOGLE_SECRET_KEY
};
